import { Fade, Popover, PopoverProps, styled } from '@mui/material';
import * as React from 'react';
import type { JSX } from 'react';

import { colorSystem } from '../../../../theme';

export interface PickerPopoverProps {
    open: boolean;
    anchorEl: HTMLElement | null;
    onClose: () => void;
    children: React.ReactNode;
    width?: number | string;
    'aria-label'?: string;
    anchorOrigin?: PopoverProps['anchorOrigin'];
    transformOrigin?: PopoverProps['transformOrigin'];
}

/** A fixed-width dialog popover that fades in, as `Grow`'s scale from the corner looks awkward at 320px. */
export function PickerPopover({
    open,
    anchorEl,
    onClose,
    children,
    width = 320,
    'aria-label': ariaLabel,
    anchorOrigin = { vertical: 'bottom', horizontal: 'left' },
    transformOrigin = { vertical: 'top', horizontal: 'left' },
}: PickerPopoverProps): JSX.Element {
    return (
        <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={anchorOrigin}
            transformOrigin={transformOrigin}
            slots={{ transition: Fade }}
            slotProps={{
                transition: { timeout: { enter: 120, exit: 80 } },
                paper: {
                    role: 'dialog',
                    'aria-label': ariaLabel,
                    sx: {
                        width,
                        mt: '4px',
                        borderRadius: '8px',
                        border: `1px solid ${colorSystem.neutral[2]}`,
                        boxShadow: '0px 8px 24px rgba(42, 49, 71, 0.12)',
                    },
                },
            }}
        >
            <Body>{children}</Body>
        </Popover>
    );
}

const Body = styled('div')({
    display: 'flex',
    flexDirection: 'column',
});
